export const getFilterValue = (filter: { name: string }[]) =>
  filter.length ? {
    filterType: 'set',
    values: filter.map((ent) => ent.name),
  } : null;

export const RevenueDetailMetricsOptions = [
  { name: 'Revenue', value: 'revenue' },
  { name: 'New', value: 'new' },
  { name: 'Upgrade', value: 'upgrade' },
  { name: 'New + Upgrade', value: 'newUpgrade' },
  { name: 'Downgrade', value: 'downgrade' },
  { name: 'Net Expansion', value: 'netExpansion' },
  { name: 'Churned (Downgrade + Cancelled)', value: 'churned' },
  { name: 'Cancelled', value: 'cancelled' },
  { name: 'Net New Revenue', value: 'netNewRevenue' },
];

export const RevenueDetailDimensionOptionsContracts = [
  { name: 'Customer' },
  { name: 'Customer Tags' },
  { name: 'Product' },
  { name: 'Product Tags' },
  { name: 'Contract' },
  { name: 'Contract Tags' },
  { name: 'Contract Line Tags' },
  { name: 'None' },
];

export const RevenueDetailDimensionOptionsSubscriptions = [
  { name: 'Customer' },
  { name: 'Customer Tags' },
  { name: 'Product' },
  { name: 'Product Tags' },
  { name: 'Subscription Tags' },
  { name: 'None' },
];
